import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyPageRoutingModule } from './my-page-routing.module';
import { LandingComponent } from './pages/landing/landing.component';
import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { LandingEmpresaComponent } from './pages/landing-empresa/landing-empresa.component';
import { LandingGeneralComponent } from './pages/landing-general/landing-general.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OnboardingEndpointsService } from './pages/onboarding/onboarding-endpoints.service';
import { LibroCompraVentaModule } from './pages/libro-compra-venta/libro-compra-venta.module';

import { ActualizarCredencialesComponent } from './pages/actualizar-credenciales/actualizar-credenciales.component'
import { ProfileCompletionCardComponent } from './pages/landing-empresa/profile-completion-card/profile-completion-card.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { GtpAreaChartComponent } from '../components/gtp-area-chart/gtp-area-chart.component';
import { GtpBarChartComponent } from '../components/gtp-bar-chart/gtp-bar-chart.component';
import { SideBarComponent } from './pages/landing/side-bar/side-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedComponentsModule } from '../components/shared-components.module';
import {MatTooltipModule} from '@angular/material/tooltip';
import { TermsModalComponent } from './pages/onboarding/terms-modal/terms-modal.component';

@NgModule({
  providers: [
    OnboardingEndpointsService,
    MatSnackBar
  ],
  declarations: [
    LandingComponent,
    OnboardingComponent,
    LandingEmpresaComponent,
    LandingGeneralComponent,
    ActualizarCredencialesComponent,
    ProfileCompletionCardComponent,
    GtpAreaChartComponent,
    GtpBarChartComponent,
    SideBarComponent,
    TermsModalComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MyPageRoutingModule,
    FormsModule,
    CommonModule,
    NgApexchartsModule,
    LibroCompraVentaModule,
    SharedComponentsModule,
    MatTooltipModule
  ]
})
export class MyPageModule { }
